import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import React from 'react'

interface DomainCellProps {
  domain: string
}

export const DomainCell = ({ domain }: DomainCellProps) => {
  return (
    <BpAnchor href={`https://${domain}`} target='_blank'>
      {domain}
    </BpAnchor>
  )
}
